import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import ElementConstants from '../../../shared/constants/elements';
import Localization from '../../../../../../common/edlio-js/models/BackendLocalization';

export default class InputPlaceholder extends React.Component {
	render() {
		let localization = new Localization(window.edlio.localizations);
		const { type, defaultValue } = this.props;

		if ( type === ElementConstants.INPUTS.TEXTAREA ) {
			return (
				<textarea
					ref='placeholderInput'
					defaultValue={localization.localize('Long Answer')}
					placeholder={localization.localize(Defaults.PLACEHOLDER)}
					onBlur={this.savePlaceholder}
					className='placeholder'
					disabled
				></textarea>
			);
		} else {
			return (
				<input
					type='text'
					ref='placeholderInput'
					defaultValue={defaultValue}
					placeholder={localization.localize(Defaults.PLACEHOLDER)}
					onBlur={this.savePlaceholder}
					className='placeholder'
					disabled
				></input>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/widgets/input-placeholder.js